import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home.vue')
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import('@/views/Auth/Register.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Auth/Login.vue')
    },
    {
        path: '/password-reset/:token',
        name: 'PasswordReset',
        component: () => import('@/views/Auth/PasswordReset.vue')
    },
    {
        path: '/verified',
        name: 'Verified',
        component: () => import('@/views/Auth/Verified.vue')
    },
    {
        path: '/tickets',
        name: 'Posts',
        component: () => import('@/views/Post/Posts.vue')
    },
    {
        path: '/tickets/:id',
        name: 'Post',
        component: () => import('@/views/Post/Post.vue')
    },
    {
        path: '/tickets/key/:key',
        name: 'PostbyKey',
        component: () => import('@/views/Post/Post.vue')
    },
    {
        path: '/mon-compte',
        name: 'MyAccount',
        component: () => import('@/views/Post/Posts.vue')
    },
    {
        path: '/404',
        name: 'Page404',
        component: () => import('@/views/UI/PageNotFound.vue')
    },
    {
        path: '*',
        name: 'PageNotFound',
        component: () => import('@/views/UI/PageNotFound.vue')
    }
]
var vueAppUrlSignaler =
    document.getElementById('app').getAttribute('page') ||
    process.env.VUE_APP_URL_SIGNALER
const router = new VueRouter({
    mode: 'history',
    base: vueAppUrlSignaler,
    routes
})

export default router
